const mode = process.env.NODE_ENV;

const base = "oraiappv2.tryoratio.com";
//mode === "production" ? "oraiappv2.tryoratio.com" : "qa.tryoratio.com";

const baseurl = base + "/mobileapp/v2/";

// const videourl =
//   mode === "production" ? "webvideoprod.tryoratio.com" : "webrtctesting.tryoratio.com";

const lessonsurl = "https://lessons.orai.com";
//mode === "production" ? "https://lessons.orai.com" : "https://lessons.tryoratio.com";

//const IBM = "ibm";
//const IBM_INIT_TEAM = "h83$iBla";

// const ssourl = mode === 'production' ?
// "https://sso.orai.pro/" :
// "https://sso.tryoratio.com/";

const amplitudeKey =
  mode === "production"
    ? "9a1e2f350a88a60ab8593b5c3e8d37c7" // prod
    : "09256dddaed95cf5d58a7aa7d1a10f6b"; // qa

const googleAnalyticsTrackingId =
  mode === "production"
    ? "UA-101932415-11" // prod
    : "UA-101932415-10"; // qa

// const jwt = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJGVjRJeENpRlIzSjVBTUFvM0hQT3YwY2xxNkpKeiIsImFkbWluIjp0cnVlLCJkZXZpY2VJZCI6bnVsbCwiZXhwIjoxNTU4Mzg2NTM0LCJpYXQiOjE1NTA2MTA1MzQsImlzcyI6Ik9yYWkiLCJzdWIiOiJPcmFpIEFwcCBBdXRoZW50aWNhdGlvbiBDbGFpbSJ9.Pxn4M_eyi5SFz2R4yEtKvyBGJdW_zWoQClPkhNIeC9aeExE2UTrsdVtNmKn_8UKzyJYAEHQuO9XcP097YAu1LKf96KWUB6rzV4tRF8oS5OJHiNjTRlM8NAU4vEVPr0By9yhsKf8clnvyelNufvuvNKtsBDWb2TblflnAJ9L_JsHKJyCOEnnieAVFNfZtm-sZlEhYZ7WcAqFtn7zKW1j9O86FJ60_rXIYpq27ZzeoJR0shMxUtAUjIXGa3XfsDsSEd1eqRc4nJUVoehNEjX-NQhPyrMqC69bEBPHZRqzaqRPhkENstx-NcqkwAhNmjyWve3hy0gp1rFOj1WuZnm8WsjNmMzikaomtEfXeWOY9HKhjLWvyUpElg_uwZOcPBdiblJvKRUs24unZAjFzyae28ITNWM87jEykJhcvEfZwADHDwWpEzZFagiNhL6P8_sT080LETc8kC8x5da_ehzIo09f8dkfck6_1IKwXCRpIwMi8MKUpV3ALFpGW4f-c0_EPoNCWR_GkRD-s6CbDyjb-2nU9R09gd_jqF3a7oS8UUY0ZJXMs-_MC7NAk8lYAddkXwlrwFzNZfwCJvIg0KzOoazPOXGqMX7jF6Y7YU7sKttw2sGDVIdDXM8I8p_oqPiYUCg_Sea1ldB5ECKecAtxv4N8oG3R6Ye95tjD2TiXHnLk';

// const devjwt = `eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJvWXVLbEh0N25qY25LTm9Wc1BZOVFnUG1YbFIyIiwiYWRtaW4iOnRydWUsImRldmljZUlkIjoyODg1MywiZXhwIjoxNTgyODE0NjgwLCJpYXQiOjE1NzUwMzg2ODAsImlzcyI6Ik9yYWkiLCJzdWIiOiJPcmFpIEFwcCBBdXRoZW50aWNhdGlvbiBDbGFpbSJ9.ajfD1tcguRQngcDcyIrinB6s9EhtX15xuXTZeYxhxF8YQoZwb3KYgEsOF1RD4_3l0GaaYQAbqJ9lK7MZhaLce3-ZTM9AAULWrQhG158RxbGgw_j-pf-UDkXBI7pzUDgkoC-VZ022NMBFwu18YFSvpGZSVnBaN-GvFYMUnRSCQHPuQITDYqVUxYpEdDhWqG-xO9UCPAC_ObLRLOZvK5IedKsNo_BGz7tEvorIc0kOH4mp8HXrTOJS-JnezVTK50Dj_r0ZTQKqfiGpvXZEK-utJ4gI_bzzyGH15PYWYhF4N5SOGPj0s1HZNliuE5CTxrG_vLSY9xNG3yZKfCl0F8yGiyU0dZaKUpKls4x1zXozdnbxL5J4SbsaxS6WTeN2ZyoDgT_nDex3h_hvaO-lSpQinbSx66A20Z9c8sKaTva32Y4ZHT6ygZrtiLWTenIDixx0PNBbr7eeEFzUmf69ENu5gdnnqK8t9j5xy6XSv45o2tjUyzHW8rPnDhFpT6OyCuKZbV5299ZkcoqsBByI-fTkZSi9O8deOqcJ94PUy1_wDymQKCIndg-6F0p9FNfLzx5Tc-3buZJcXSyS8LDceHQhoB7j8P0aQdnBE8rezUMq9Yc0WTgg4PaAysfI15yiwnxhpFvlOxWCcd3NS30MbMY40KhtFaf8IHcM2nQNuf6OVyo`;
// const devuid = "oYuKlHt7njcnKNoVsPY9QgPmXlR2";
const wssurl = "wss://" + baseurl;

const stripeKey =
  mode === "production"
    ? "pk_live_cK1c5Xb0Z1qDXVk3qSPkGSfo"
    : "pk_test_51H9MuOBWEMiwCiSVREKTCNLGm8bI3BvN2ELbYfWPHTP6EXPNRNARFEYnjRqyLmsqx9rNwjQA8qPcO1HGBHcxpp7m001rSv8PWN";
const currentLearnerTeam = "currentLearnerTeam";

export default {
  serverURL: `https://${baseurl}`,
  // ssoURL: ssourl,
  amplitudeKey,
  base,
  wssurl,
  // videourl,
  lessonsurl,
  stripeKey,
  googleAnalyticsTrackingId,
  currentLearnerTeam,
  // videosocketurl: `wss://${videourl}`,
  // devuid
};
